<template>
  <div class="document-container">
    <div class="document">
      <div class="header">
        <es-header>
          <template #header>
            <div class="header-title">Matched DirectMatch Records</div>
          </template>
        </es-header>
      </div>
      <es-loader v-if="loading" style="margin: 6.5rem"/>
      <es-exception
        v-else-if="!loading && loadingError"
        exceptionMessage="There was an issue. Please try again or contact your administrator."
        margin="0rem"
        style="padding: 6.5rem"/>
      <div v-else class="content">
        <table class="table is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th>Index Date</th>
              <th>Date Matched</th>
              <th>School Year</th>
              <th>Match Type</th>
              <th>Decision</th>
              <th>DSS</th>
              <th>Match Option</th>
              <th>Location Information</th>
              <th>Local ID</th>
              <th>Source</th>
              <th>Transaction Info</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="match in matches" :key="match.id">
              <td>{{ match.matchTypeFileDate | formatDateMMDDYYYY }}</td>
              <td>{{ match.matchDate | formatDateMMDDYYYY }}</td>
              <td>{{ match.schoolYear }}</td>
              <td>{{ programDescription(match.programCode) }}</td>
              <td>Match</td>
              <td>{{ match.programUniqueId }}</td>
              <td>{{ match.matchType.description }}</td>
              <td>
                <div>
                  <div v-if="match.districtCode">
                    <router-link
                      :to="{
                        name: 'DmDistrictInfoDetails',
                        params: { code: match.districtCode  },
                      }"
                      class="has-text-weight-bold has-text-primary" style="font-size:14px">
                      {{ match.district.location.name }}
                    </router-link>
                    <span class="has-text-grey" style="padding-left: 0.25rem">
                      ({{ match.districtCode }})
                    </span>
                  </div>
                  <div v-else>
                    Multiple Districts
                  </div>
                  <div>
                    <div v-if="match.schoolCode">
                      <router-link
                        :to="{
                          name: 'DmSchoolInfoDetails',
                          params: {
                            districtCode: match.districtCode,
                            schoolCode: match.schoolCode,
                          },
                        }"
                        class="is-italic">
                          {{ match.school.location.name }}
                        </router-link>
                        <span class="has-text-grey is-italic" style="padding-left: 0.25rem">
                          ({{ match.school.code }})
                        </span>
                    </div>
                    <div v-else class="has-text-grey is-italic">
                      Multiple Schools
                    </div>
                  </div>
                </div>
              </td>
              <td>{{ match.sourceId }}</td>
              <td>{{ match.sourceCode }}</td>
              <td>{{ match.matchTransId }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="100%">
                <es-pager :totalCount="matchesTotalCount"/>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

import EsException from '@/components/EsException.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsPager from '@/components/EsPager.vue';
import PersonProfileDmRow from '@/components/PersonProfileDmRow.vue';

export default {
  components: {
    EsException,
    EsLoader,
    EsHeader,
    EsPager,
    PersonProfileDmRow,
  },
  props: {
    matches: {
      type: Array,
    },
    matchesTotalCount: {
      type: Number,
    },
  },
  data() {
    return {
      loading: true,
      loadingError: null,
    };
  },
  created() {
    this.onLoad();
  },
  computed: {
    ...mapGetters('lookups', [
      'allPrograms',
    ]),
  },
  methods: {
    ...mapActions('lookups', [
      'loadPrograms',
    ]),
    programDescription(programCode) {
      if (this.matches.length) {
        return this.allPrograms.find(p => p.code === programCode).description;
      }
    },
    async onLoad() {
      try {
        this.loading = true;
        this.loadingError = false;

        await this.loadPrograms();
      } catch (e) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style lang="sass" scoped>
</style>
